<template>
  <q-dialog
    v-model="shown"
  >
    <q-card style="min-width: 600px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Payment Connector Receipt
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section
        v-if="currentRegisterClient"
        class="row"
      >
        <q-btn
          outline
          label="Print"
          icon="print"
          @click="() => printReceipt()"
        />
      </q-card-section>
      <q-card-section>
        <iframe
          ref="receiptIframe"
          :srcdoc="receiptDataFormatted"
          @load="() => setupIFrame()"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'PaymentConnectorReceiptDialog',
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      receiptData: null,
      isCustomerReceipt: false,
      paymentId: null,
      receiptType: null
    }
  },
  computed: {
    receiptDataFormatted () {
      if (this.receiptType === 'html') {
        return `<div>${this.receiptData}</div>`
      } else if (this.receiptType === 'text' && Array.isArray(this.receiptData)) {
        const receiptDataBreakByLine = this.receiptData.join('<br>')
        return `<body>${receiptDataBreakByLine}</body>`
      } else if (this.receiptType === 'text' && typeof (this.receiptData) === 'string') {
        return `<body>${this.receiptData.split('\n').join('<br>')}</body>`
      } else {
        return `<body>${this.receiptData}</body>`
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  context: ['currentRegisterClient'],
  methods: {
    show (receiptData, receiptType, paymentId, isCustomerReceipt = false) {
      this.receiptType = receiptType
      this.receiptData = receiptData
      this.isCustomerReceipt = isCustomerReceipt
      this.paymentId = paymentId
      this.shown = true
    },
    setupIFrame () {
      const iFrame = this.$refs.receiptIframe
      // Need to add 50px to height to prevent vertical scrolling as the scroll height is always a bit too short
      iFrame.height = iFrame.contentWindow.document.body.scrollHeight + 50 + 'px'
      // Use 100% width to prevent being mashed into a small width
      iFrame.width = '100%'
      // Need to make width 99% to prevent horizontal scrolling
      iFrame.contentWindow.document.body.style.width = '99%'
    },
    printReceipt () {
      this.$paymentConnectorHandler.printCachedReceipt(this.currentRegisterClient, this.paymentId, this.isCustomerReceipt)
    }
  }
}

</script>
<style lang="scss" scoped>

</style>
